module.exports = __webpack_public_path__ + "static/bg-8199c298ee5dd61dd304037c217cca02.jpg";